import { useTheme } from "@emotion/react";
import {
  Button,
  Slider,
  Stack,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { imageEditorActions } from "store/imageEditor";
import { IMAGE_EDITOR_MODES } from "store/imageEditor";

export default function ImageEditorControls() {
  
  const dispatch = useDispatch();
  const imageEditorState = useSelector((state) => state.imageEditor);
  const theme = useTheme();

  return (
    <Stack spacing={2}>
      <Stack>
        <Typography
          textAlign="center"
          sx={{
            color: theme.palette.text.main,
          }}
        >
          Brush Size
        </Typography>
        <Slider
          min={5}
          max={100}
          value={imageEditorState.brushSize}
          onChange={(_, val) => dispatch(imageEditorActions.setBrushSize(val))}
        />
      </Stack>

      {/* Paint / Erase toggle */}
      <ToggleButtonGroup
        fullWidth
        value={imageEditorState.mode}
        exclusive
        onChange={(_, val) => val && dispatch(imageEditorActions.setMode(val))}
        aria-label="mode"
      >
        <ToggleButton value={IMAGE_EDITOR_MODES.paint}>Paint</ToggleButton>
        <ToggleButton value={IMAGE_EDITOR_MODES.rect}>Rect</ToggleButton>
        <ToggleButton value={IMAGE_EDITOR_MODES.erase}>Erase</ToggleButton>
      </ToggleButtonGroup>

      <TextField
        value={imageEditorState.prompt}
        label="Editing Instructions"
        onChange={(event) => dispatch(imageEditorActions.setPrompt(event.target.value))}
        multiline
        minRows={4}
        maxRows={4}
      />
      
      

    </Stack>
  );
}
